import dayjs from 'dayjs'
import keys from 'constants/keys'
import { StepType, TaskFormData } from './types'
import { DEFAULT_ALLOWED_OVERDUE_DAYS, PRIORITY_VALUES } from '../utils'

/** Restore saved settings without mutating the committed form snapshot. */
export function getTaskSettingsDefaults(formData: Partial<TaskFormData>, isVmTask: boolean, uid?: string) {
  const saved = formData[StepType.TASK_SETTINGS]

  if (saved) return { ...saved, send_schedule_push: saved.send_schedule_push ?? true }

  const timeframe = formData[StepType.TIME_FRAME_SELECTION]

  return {
    audience: { groups: [], users: [], tags: [] },
    view: isVmTask ? 3 : 4,
    is_individual_results: false,
    send_schedule_push: true,
    from_ts: timeframe?.from_ts ?? dayjs().toISOString(),
    deadline: timeframe?.deadline ?? dayjs().add(8, 'hour').toISOString(),
    allowed_overdue_days: timeframe?.allowed_overdue_days ?? DEFAULT_ALLOWED_OVERDUE_DAYS,
    priority: PRIORITY_VALUES.NONE,
    disable_gallery_upload: false,
    rework_limit: null,
    allow_completion_after_deadline: false,
    watchers: uid ? [uid] : [],
    auditors: [],
    type: isVmTask ? keys.TASK_V2_TYPES.VM_TASK : keys.TASK_V2_TYPES.TASK,
  }
}
